// ══════════════════════════════════════════════════════
// $REDHORSE Dashboard - Frontend Config
// Change these values when launching your own token
// ══════════════════════════════════════════════════════

const CONFIG = {
  // Token info
  TOKEN_NAME: '$REDHORSE',
  TOKEN_SYMBOL: 'REDHORSE',
  TOKEN_TAGLINE: 'Fire Horse Burns Everything',

  // Solana addresses
  TOKEN_CA: '13k29p5nDFTYRbAVZxMiTytewJMeBQEJQoRzxV69pump',
  PAIR_ADDRESS: '22bJP3i4iAL3opsELjHeA7Ey3f1mBGvGNaTe66FSmUNF',
  BUYBACK_WALLET: '7sspFtPKwn8NyzkVxcHs3nonvgtoDo8GYfeKocTbSYfb',

  // Proxy (Cloudflare Worker)
  PROXY_URL: 'https://api.red-horse.fun',

  // Burn tracking
  INITIAL_SUPPLY: 1_000_000_000,

  // Social links
  TWITTER_URL: 'https://x.com/Chet_Rippo',
  TELEGRAM_URL: 'https://telegram.org',

  // Refresh interval (ms)
  REFRESH_INTERVAL: 30000,
};

export default CONFIG;
